import { isCopperLayer } from "@buildwithflux/models";
/** Get the thickness of the board between the top and bottom copper layers, not including
 * the outer copper, soldermask or overlay layers.
 */
export function getSubstrateThickness(layers) {
    // NOTE: same order as in PcbNodeBakedRulesDeriver
    let orderedStackup = Object.values(layers).sort((a, b) => a.order - b.order);
    orderedStackup = orderedStackup.slice(orderedStackup.findIndex((l) => isCopperLayer(l)) + 1);
    let thickness = 0;
    for (const layer of orderedStackup) {
        if (layer.orientation === "Bottom") {
            break;
        }
        thickness += layer.thickness;
    }
    return thickness;
}
//# sourceMappingURL=getSubstrateThickness.js.map